import { Delete, Edit } from "@mui/icons-material";
import { Button, Modal, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { IMaterial } from "../../models/materials";
import { deleteMaterial, getMaterials } from "../../redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { RootState } from '../../redux/store';
import { MyBoxModal } from "../../styled-components";
import { MyForm } from './components';
import { MyRenderCell } from "./components/MyRenderCell";



export const Materials = () => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);

    const dispatch = useAppDispatch();
    const { materials = [] } = useAppSelector((state: RootState) => state.materials);

    useEffect(() => {
        dispatch(getMaterials() as any);
    }, [dispatch])

    const onDelete = (material: IMaterial) => {
        dispatch(deleteMaterial(material) as any);
    }

    const Columns: GridColDef[] = [
        {
            field: "action",
            headerName: "Action",
            width: 130,
            sortable: false,
            align: "right",
            renderCell: (params) => {
                const onClick = (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation(); // don't select this row after clicking

                    return alert(JSON.stringify(params.row, null, 4));
                };
                const deleteMaterial = (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation(); // don't select this row after clicking

                    onDelete(params.row as any);
                };
                return (
                    <>
                        <Tooltip title="Edit" >
                            <Button onClick={onClick}><Edit /></Button>
                        </Tooltip>
                        <Tooltip title="Delete" >
                            <Button onClick={deleteMaterial}><Delete /></Button>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: 'id',
            headerName: 'Book Materials ID',
            width: 100
        },
        {
            field: 'isbn',
            headerName: 'ISBN',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'isbn10',
            headerName: 'ISBN 10',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'author',
            headerName: 'Author',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'edition',
            headerName: 'Edition',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'publisher',
            headerName: 'Publisher',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'discountId',
            headerName: 'Discount Id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'weight',
            headerName: 'Weight',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'length',
            headerName: 'Length',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'width',
            headerName: 'Width',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'copyright',
            headerName: 'Copyright',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'custom',
            headerName: 'Custom',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'nationalISBN',
            headerName: 'National ISBN',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'avalibleQuantity',
            headerName: 'Avalible Quantity',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        }
    ]
    return (
        <div>
            <Typography variant="h4" component="h1">Materials</Typography>
            <br />
            <Button onClick={openDialog} >Add</Button>
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid getRowId={(row: IMaterial) => row.isbn} rows={materials} columns={Columns} pageSize={10} rowsPerPageOptions={[10, 50, 100]} checkboxSelection />
            </div>
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} />
                </MyBoxModal>
            </Modal>
        </div >
    )
}
